// export const token = {
//   'x-access-token': localStorage.getItem("x-access-token"),
// }
export const token = {
  get: () => localStorage.getItem("x-access-token"),
  set: (value) => localStorage.setItem("x-access-token", value),
};
